import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';
import PDFViewer from '../PDFViewer';

export default class DocumentPreview extends React.Component {
  isPDF(type) {
    return type.indexOf('pdf') > -1;
  }

  isImage(fileType) {
    let is = false;
    const types = ['png', 'jpg', 'jpeg'];
    _.each(types, (type) => {
      if (fileType.indexOf(type) > -1) is = true;
    });

    return is;
  }

  renderImage = () => {
    if (this.props.renderDownloadableImage) {
      return (
        (<div data-testid="div-324815bc">
          <a
            data-testid="a-2eb3b949"
            href={this.props.url}
            target="_blank"
            rel="noreferrer">
            <img
              data-testid="img-71e25ed6"
              width="100%"
              height="100%"
              src={this.props.url}
              alt="POC" />
          </a>
        </div>)
      );
    }
    return (
      <img
        data-testid="img-2f38dd91"
        width="100%"
        height="100%"
        src={this.props.url}
        alt="POC" />
    );
  };

  renderFileName() {
    return <div data-testid="div-6190df33"> {this.props.name} </div>;
  }

  renderPreview() {
    const fileType = this.props.type || this.props.url;

    if (this.isPDF(fileType)) {
      return (
        <PDFViewer
          height={this.props.height}
          width={this.props.width}
          displayInGridView={this.props.displayInGridView}
          file={this.props.url}
        />
      );
    }

    if (this.isImage(fileType)) {
      return this.renderImage();
    }

    return <img data-testid="img-ba70f8f6" src={this.props.url} alt="" />;
  }

  render() {
    const removeIcon = (
      <i
        data-testid="i-e8052131"
        className="icon glyphicon glyphicon-remove"
        onClick={() => this.props.handleRemove(this.props.url)}
        style={
          this.props.removeIconStyles
            ? this.props.removeIconStyles
            : {
                color: 'red',
                marginLeft: '10px',
                position: 'absolute',
                top: 10,
                cursor: 'pointer',
              }
        } />
    );

    return (
      (<div data-testid="div-34120d78" className="overflow-visible flex">
        {this.props.useFileName ? this.renderFileName() : this.renderPreview()}
        {this.props.handleRemove && removeIcon}
      </div>)
    );
  }
}

DocumentPreview.propTypes = {
  url: PropTypes.string.isRequired,
};
